export default __webpack_public_path__ + "static/bud-3fa041905dbab5cf5b8cc54c3a936085.png";